<template>
  <div>

    <div class="mui-content">
      <form id='login-form' class="mui-input-group">
        <div class="mui-input-row">
          <label>手机号码</label>
          <button @click.prevent="" style="width: 25%;float: right;padding: 6px;height: 38px;margin: 1px 0;"
                  @click="sendSMS">
            {{ sendSMSCountDown }}
          </button>
          <input id='phone' type="text" v-model="phone" placeholder="请输入手机号码" style="width:40%">
        </div>

        <div class="mui-input-row">
          <label>验证码</label>
          <input id='yzm' type="text" v-model="yzm" placeholder="请输入验证码" class="mui-input-clear mui-input">
        </div>

      </form>
      <div style="text-align: center;margin-top:20px;">
        <mt-button type="primary" @click.prevent="" @click="smslogin" style="width: 80vw;">登录</mt-button>

      </div>
    </div>


  </div>
</template>

<script>

import {Toast} from "mint-ui";

export default {
  name: 'smslogin',
  data() {
    return {
      phone: '',
      yzm: '',
      title: '短信登录',
      sendSMSCountDown: '获取验证码'
    }
  },
  methods: {

    isPhoneNo(phone) {
      var pattern = /^1[0-9]{10}$/
      return pattern.test(phone)
    },
    sendSMS() {
      if (!this.isPhoneNo(this.phone)) {
        Toast('手机号错误')
        return false
      }

      if (window.localStorage.getItem("sendSMSCountDown") === "" || window.localStorage.getItem("sendSMSCountDown") === '0') {
        window.localStorage.setItem("sendSMSCountDown", 0)
      } else {
        Toast("操作太频繁，请等待60s");
        return;
      }


      if (this.sendSMSCountDown === '获取验证码' && (window.localStorage.getItem("sendSMSCountDown") === '0')) {
        var that = this;
        this.$http.post('api/gather/sendSMS', {
          'mobile': this.phone,
          'openid': window.localStorage.getItem("userOpenid")
        }, {emulateJSON: true})
          .then(function (data) {
            Toast(data.body.msg)
            if (data.body.code === 1) {

              var countinterval = setInterval(function () {

                var s = that.sendSMSCountDown === "获取验证码" ? 60 : that.sendSMSCountDown
                if (s <= 0) {

                  window.localStorage.setItem("sendSMSCountDown", 0)
                  that.sendSMSCountDown = "获取验证码"
                  clearInterval(countinterval);
                  return;
                }
                window.localStorage.setItem("sendSMSCountDown", s - 1)
                that.sendSMSCountDown = s - 1

              }, 1000)
            }
          })
      } else {

        alert("error")
      }
    },
    smslogin(){
        if(this.phone===""){
          Toast("手机号为空!")
          return
        }
        if(this.yzm===""){
          Toast("验证码为空!")
          return
        }


      this.$http.post('api/gather/smslogin', { 'phone':this.phone,'code':this.yzm,'openid': window.localStorage.getItem('userOpenid')}, {emulateJSON: true})
        .then(function (data) {
          Toast(data.body.msg)
          if (data.body.code === 1) {
            window.localStorage.setItem('uid', data.body.data.uid)
            setTimeout(() => {
              this.$router.push({path: '/home'})
            }, 2000)
          }else if(data.body.data.code===-1){
            //未注册
              this.$router.push({path: '/user/register?from=1&phone='+this.phone})
          }
        })
    }
  },
  created() {
    window.localStorage.setItem('sendSMSCountDown', '0')
    this.$emit('getTitle', this.title)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/user/smslogin.vue